function CheckToken(){
  const tokenString = sessionStorage.getItem('token');
  // const userToken = JSON.parse(tokenString);
  const token =  tokenString===null? false:true
  // console.log(token);
  return token;
}

export default CheckToken;